import React, { useState } from 'react';
import { FaPlus, FaMinus, FaTrash, FaRegEdit, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { BASE_URL } from '../../../../BaseUrl';
import { currencySymbolLeft } from '../../../../functions/Functions';

const SidebarCartItem = ({ item, onAddToCart, onRemoveFromCart, onEditInstruction, showImage = true }) => {
  const [isAddonsOpen, setIsAddonsOpen] = useState(false);

  return (
    <div className="cart-item-card bg-white p-3 shadow-sm mb-3 position-relative sidebar-cart-card">
      <div className="d-flex align-items-start">
        <img src={item.image ? BASE_URL + item.image : "/assets/img/default-item.jpeg"} 
             onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
             alt={item.name} className="sidebar-cart-img" />
        
        <div className="flex-grow-1 ml-3 d-flex flex-column sidebar-cart-content">
          <div className="d-flex justify-content-between align-items-start">
            <div className="sidebar-cart-name font-weight-bold pr-2">
              {item.name}
            </div>
            <div className="sidebar-cart-price-total">
              {currencySymbolLeft()} {item.sub_total}
            </div>
          </div>
          
          <div className="sidebar-cart-price-each">
            {currencySymbolLeft()} {item.price} each
          </div>
          
          {item.comments && (
            <div className="text-truncate sidebar-cart-note">
              Note: {item.comments}
            </div>
          )}

          {item.properties && item.properties.length > 0 && (
            <div className="mt-2">
              <div 
                className="d-flex align-items-center sidebar-cart-addons-toggle" 
                onClick={() => setIsAddonsOpen(!isAddonsOpen)}
              >
                View Add-ons <span className={`ml-1 sidebar-addons-icon ${isAddonsOpen ? 'open' : ''}`}><FaChevronDown size={10} /></span>
              </div>
              
              <div className={`sidebar-addon-container ${isAddonsOpen ? 'open' : ''}`} style={{ display: isAddonsOpen ? 'block' : 'none', marginTop: '4px' }}>
                {item.properties.map((prop, idx) => (
                  <div key={idx} className="d-flex align-items-center sidebar-cart-addon-item">
                    <span className="sidebar-cart-addon-qty mr-1">{prop.quantity}x</span>
                    <span className="text-muted">{prop.name}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <div className="d-flex justify-content-between align-items-center mt-2 sidebar-cart-actions">
            <button 
              className="btn btn-sm d-flex align-items-center sidebar-cart-edit-btn"
              onClick={() => onEditInstruction(item)}
            >
              <FaRegEdit className="mr-1" /> {item.comments ? 'Edit Note' : 'Add Note'}
            </button>
            
            <div className="d-flex align-items-center justify-content-between shadow-sm sidebar-cart-qty-ctrl">
              <button className="btn border-0 text-white d-flex align-items-center justify-content-center p-0 sidebar-cart-qty-btn" onClick={() => onRemoveFromCart(item)}>
                {item.quantity === 1 ? <FaTrash className='carticons' /> : <FaMinus className='carticons'/>}
              </button>
              <span className="sidebar-cart-qty-val mx-1">
                {item.quantity}
              </span>
              <button className="btn border-0 text-white d-flex align-items-center justify-content-center p-0 sidebar-cart-qty-btn" onClick={() => onAddToCart(item, item.variation, item.properties)}>
                <FaPlus className='carticons' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarCartItem;
